export default __webpack_public_path__ + "static/media/tick-active.7bbaf7fe.svg";